var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHezaibiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 13,
    height: 13,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2,
    width: 12,
    height: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 12V6.44922H5.15625V9.01562L7.53516 6.44922H8.51172L6.33594 8.78516L8.57422 12H7.67969L5.8125 9.32031L5.15625 10.0234V12H4.42188ZM9.15625 12V6.44922H10.0273L12.1289 11V6.44922H12.8008V12H11.9453L9.81641 7.44922V12H9.15625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHezaibiao);
export default __webpack_public_path__ + "static/media/hezaibiao.8dfa923e47f6e4831b9562a56f384f92.svg";
export { ForwardRef as ReactComponent };